import type { AiHandoffReason } from "api/voice";

export const aiHandoffReasonText = (
  reason: AiHandoffReason | null | undefined,
  sentByName?: string | null
): string | null => {
  switch (reason) {
    case "timer":
      return "Team rang for 15 sec, then the AI agent answered";
    case "sent":
      return `${sentByName || "A teammate"} sent the call to the AI agent`;
    case "silenced":
      return "Everyone silenced the call, so the AI agent answered";
    default:
      return null;
  }
};
